import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ServiceHighlights from "@/components/ServiceHighlights";
import About from "@/components/About";
import LabourCodes from "@/components/LabourCodes";
import RegistrationServices from "@/components/RegistrationServices";
import Registers from "@/components/Registers";
import ComplianceCalendar from "@/components/ComplianceCalendar";
import GapAssessment from "@/components/GapAssessment";
import Industries from "@/components/Industries";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";

const Home = () => (
    <div className="bg-[#0A1128] text-slate-100 min-h-screen">
        <Navbar />
        <main>
            <Hero />
            <Marquee />
            <ServiceHighlights />
            <About />
            <LabourCodes />
            <RegistrationServices />
            <Registers />
            <ComplianceCalendar />
            <GapAssessment />
            <Industries />
            <WhyUs />
            <Process />
            <Contact />
        </main>
        <Footer />
        <FloatingButtons />
    </div>
);

export default Home;
